import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MainLayoutComponent } from '@app/shared/layout/app-layouts/main-layout.component';
import { ActionNoPermissionUiService } from './action-no-permission-ui.service';
import { ActionNoPermissionState } from './action-no-permission-state';

@Component({
    selector: 'app-action-no-permission-ui',
    templateUrl: './action-no-permission-ui.component.html',
})

export class ActionNoPermissionUiComponent implements OnInit, OnDestroy {
    show = false;

    static rootUrl: string = '';

    private subscription: Subscription;

    constructor(
        private _actionNoPermissionService: ActionNoPermissionUiService,
        private _router: Router,
    ) { }

    ngOnInit() {
        this.subscription = this._actionNoPermissionService.actionNoPermissionState
            .subscribe((state: ActionNoPermissionState) => {
                this.show = state.show;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public close() {
        this._actionNoPermissionService.hide();
    }
}